import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import NumberInputStegContainer, { NumberFormatter } from '../Shared/Scripts/Components/NumberInputStegComponent';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import { NumberValidering } from '../Shared/Scripts/Utilities/Validering';
import VarighetValg from './Utilities/VarighetTypeValg';
import BetaleValg from './Utilities/BetaleTypeValg';
import VeilederNordenDto from './Models/VeilederNordenDto';
import {StamdataNordenHelgradModel } from './Models/StamdataNordenHelgradModel';
import { VeilederNordenAppState } from './Store';
import * as ValgTypes from './Store/Valg/Types';
import { ResultatValg, ResultatValgValidering } from './Store/Resultat/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import * as Ids from './Models/Ids';
import VarighetTypeValg from './Utilities/VarighetTypeValg';
import { updateValidation } from './Store/Resultat/Actions';
import Resultat from './Components/Resultat';
import UtbetalingComponent from './Components/UtbetalingComponent';
import SiteImproveHandler, { SiteImproveState, SiteImproveEvents, SiteImproveKategorier } from '../Shared/Scripts/Utilities/SiteImproveEventsHandler';

interface AppOwnProps {}

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederNordenDto>();
const NumberInputStegComponent = NumberInputStegContainer<VeilederNordenDto>();

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

interface AppState {
}

class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
        };
    }

    private maksSkolepenger(state: ValgTypes.ValgState, resultat: ResultatValg, satser: StamdataNordenHelgradModel | null) {
        if(satser === null)
            return 0;

        if(state.aVarighet?.value === VarighetTypeValg.a1_hele) {
            return satser.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN;
        } else {
            return satser.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN / 2;
        }
    }

    render(): JSX.Element {
        const { valg, dispatchUpdateValg, dispatchUpdateValidering, epiContext, satser, resultat } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;

        function registerSiteImproveEvents(): void {
            if(!SiteImproveState.Startet) {
                if(valg.aVarighet != undefined) {
                    //veileder påstartet
                    SiteImproveState.Startet = true;
                    SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, SiteImproveEvents.VeilederStart, SiteImproveHandler.hentOverskrift());
                }
            }

            if(!SiteImproveState.Fullfort) {
                if(resultat.visBoksD) {
                    //veileder fullført
                    SiteImproveState.Fullfort = true;
                    SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, SiteImproveEvents.VeilederFullfort, SiteImproveHandler.hentOverskrift());
                }
            }
        }

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {

            return (
                <div>
                    <div className="c-veileder">
                        {registerSiteImproveEvents()}
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksA}
                            tittel={contentResolver(epiContext, 'varighetTittel')}
                            forklaring={contentResolver(epiContext, 'varighetIngress')}
                            sporsmal="varighetLedetekst"
                            valg={VarighetValg.varighetValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ aVarighet: nyttValg });
                            }}
                            neverCollapse={true}
                            classModifier="c-veileder__panel--input-white"
                            value={valg.aVarighet}
                        />
                        {resultat.visBoksB && (
                            <RadioButtonsStegComponent
                                sporsmalId={Ids.BoksB}
                                tittel={contentResolver(epiContext, 'betaleTittel')}
                                forklaring={contentResolver(epiContext, 'betaleIngress')}
                                sporsmal="betaleLedetekst"
                                valg={BetaleValg.betaleValg}
                                onInputChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ bBetale: nyttValg });
                                }}
                                value={valg.bBetale}
                            />
                        )}
                        {resultat.visBoksBx && (
                            <RadioButtonsStegComponent
                                sporsmalId={Ids.BoksB}
                                tittel={contentResolver(epiContext, 'betaleTittel')}
                                forklaring={contentResolver(epiContext, 'betaleIngress2')}
                                sporsmal="betaleLedetekst"
                                valg={BetaleValg.betaleValg}
                                onInputChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ bBetale: nyttValg });
                                }}
                                value={valg.bBetale}
                            />
                        )}
                        {resultat.visBoksC && (
                            this.skolepengerBoks(
                                valg,
                                resultat,
                                locale,
                                valuta,
                                dispatchUpdateValg,
                                dispatchUpdateValidering,
                                epiContext,
                                satser
                            )    
                        )}
                        {resultat.visBoksD && (
                            <Resultat 
                                satser = {satser}
                                valg = {valg}
                                valuta = {valuta}
                                locale = {locale}
                                visUtbetalingsPlanHandler = {(visPlanen: boolean): void => {
                                    dispatchUpdateValg({visBetPlan: visPlanen});
                                }}
                            />
                        )}
                        {resultat.visBetPlan && 
                            (
                                <UtbetalingComponent 
                                    valg={valg} 
                                    satser={satser} 
                                    resultat={resultat}
                                    locale={locale}
                                    valuta={valuta}
                                />
                            )
                        }
                    </div>        
                </div>
            )
        } else {
            return <div>Laster...</div>;
        }
    }

    private skolepengerBoks(
        valg: ValgTypes.ValgState,
        resultat: ResultatValg,
        locale: string,
        valuta: string,
        dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void,
        dispatchUpdateValidering: (result: Partial<ResultatValgValidering>) => void,
        epiContext: EpiContext<VeilederNordenDto>,
        satser: StamdataNordenHelgradModel | null,
    ): React.ReactNode {
        const maxSkolepenger = this.maksSkolepenger(valg, resultat, satser);
        const skolepengerInfoKey = this.skolepengerInfo(valg);
        const infoElement = (
            <div>
                <p>
                    {contentResolver(epiContext, skolepengerInfoKey)}
                    <span> {this.tilPengerFormat(maxSkolepenger, locale)}&nbsp;{valuta}.</span>
                </p>
                {contentResolver(epiContext, 'skolepengerInfoBelop')}
            </div>
        );

        const formatter: NumberFormatter = {
            toFormattetString: (v: number): string => this.tilPengerFormat(v, locale),
            toParsableAsNumber: (v: string): string => this.fraPengerFormat(v, locale),
        };

        return (
            <NumberInputStegComponent
                sporsmalId={Ids.BoksC}
                sporsmal="skolepengerLedetekstBelop"
                tittel={contentResolver(epiContext, 'skolepengerTittelBelop')}
                forklaring={infoElement}
                inputId="c1"
                placeholder="0"
                decimals={0}
                value={valg.cSkolepengerBelop}
                postfix={valuta}
                ctaText="skolepengerCtaBekreft"
                validering={this.skolepengerValidering(maxSkolepenger, epiContext.locale)}
                numberDisplayFormatter={formatter}
                onInputChange={(nyttValg: number | undefined): void => {
                    dispatchUpdateValg({ cSkolepengerBelop: nyttValg });
                }}
                onValidationChanged={(result: ValideringsResultat | undefined): void =>
                    dispatchUpdateValidering({ cValidation: result })
                }
                preValidation={resultat.cValidation}
                validationChecksum={maxSkolepenger}
            />
        );
    }

    private skolepengerInfo = (state: ValgTypes.ValgState): keyof VeilederNordenDto => {
        if (state.aVarighet?.value === VarighetTypeValg.a1_hele) {
            return 'skolepengerMaksFulltidHeltAr';
        } 
        
        if (state.aVarighet?.value === VarighetTypeValg.a2_host || state.aVarighet?.value === VarighetTypeValg.a3_vaar) {
            return 'skolepengerMaksFulltidHalvtAr';
        }
        
        return 'skolepengerFeil';
    };

    private tilPengerFormat = (verdi: number, locale: string): string => {
        return new Intl.NumberFormat(locale, {
            style: 'decimal',
            maximumFractionDigits: 0,
        }).format(verdi);
    };
    
    private fraPengerFormat = (formatertSomPenger: string, locale: string): string => {
        if (locale.startsWith('en')) {
            // Fjerner tusenskilletegn , og spaces
            return formatertSomPenger.replace(/\s+|,+/g, '');
        }
    
        // for nn-NO og nb-NO er tusenskilletegn mellomrom
        return formatertSomPenger.replace(/\s+/g, '');
    };

    private skolepengerValidering = (maxVerdi: number, locale: string): NumberValidering<VeilederNordenDto> => {
        return {
            min: 0,
            max: maxVerdi,
            minFeil: 'skolepengerObsMeldingMin',
            maxFeil: 'skolepengerObsMeldingMax',
            variablesMap: new Map<string, string>([['${belop}', this.tilPengerFormat(maxVerdi, locale)]]),
        };
    };
}

export interface ValideringsResultat {
    isValid: boolean;
    isWarning: boolean;
    feilElement: JSX.Element | null;
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederNordenDto>;
    resultat: ResultatValg;
    satser: StamdataNordenHelgradModel | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
    dispatchUpdateValidering: (validation: Partial<ResultatValgValidering>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederNordenAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
    dispatchUpdateValidering: (validation: Partial<ResultatValgValidering>): void => {
        dispatch(updateValidation(validation));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederNordenAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);